import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import apiMiddleware from "../api/apiMiddleware";

function ProtectedRoute({ children }) {
  const token =
    localStorage.getItem("admin_token") || localStorage.getItem("token");

  const [isChecking, setIsChecking] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      if (!token) {
        if (mounted) {
          setIsAllowed(false);
          setIsChecking(false);
        }
        return;
      }

      try {
        // Server-side role protection (authoritative)
        await apiMiddleware.get("/check-admin-login");
        if (mounted) {
          setIsAllowed(true);
          setIsChecking(false);
        }
      } catch (e) {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("admin_user");
        // legacy cleanup (if any)
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (mounted) {
          setIsAllowed(false);
          setIsChecking(false);
        }
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, [token]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-3 text-gray-600">
          <i className="fi fi-rr-spinner animate-spin"></i>
          <span className="text-sm font-medium">Checking session…</span>
        </div>
      </div>
    );
  }

  if (!isAllowed) return <Navigate to="/login" />;

  return children;
}

export default ProtectedRoute;
